// Onglets de la fiche produit (snippets/snk-product-tabs.liquid) : un panneau visible à la fois, onglet actif en noir
// (aria-selected), clavier : flèches gauche/droite (en boucle), Début, Fin. Sans JavaScript, tous les panneaux restent
// visibles : le script masque les autres au chargement.
if (!customElements.get('snk-product-tabs')) {
  customElements.define(
    'snk-product-tabs',
    class SnkProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = this.tabs.map((tab) => this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));
        const initial = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.select(initial < 0 ? 0 : initial, false);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, false));
          tab.addEventListener('keydown', (event) => {
            const moves = { ArrowRight: 1, ArrowLeft: -1 };
            let next = null;
            if (event.key in moves) next = (index + moves[event.key] + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === null) return;
            event.preventDefault();
            this.select(next, true);
          });
        });
      }

      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !active;
        });
        if (focus) this.tabs[index].focus();
      }
    }
  );
}
